module.exports = __webpack_public_path__ + "static/cag10-2352407238be6e17040709d90bb3e9d0.png";